// extracted by mini-css-extract-plugin
module.exports = {"bb-featured-country-news":"bb-featured-country-news__rnyos"};